// Démo rapide : [data-validate="email"] applique un état en blur
document.addEventListener('blur', (e) => {
    const inp = e.target.closest('input[data-validate="email"]');
    if (!inp) return;
    const wrap = inp.closest('.form-field'); if (!wrap) return;
    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp.value);
    wrap.classList.toggle('form-field--ok', ok);
    wrap.classList.toggle('form-field--error', !ok);
}, true);
